import { settings } from '@/main/config/settings'

export const makeApiUrl = (path: string): string => `${settings.BASE_URL}${path}`
export const makeApiV2Url = (path: string): string => `${settings.BASE_URL}/v2${path}`
export const makeViaCepUrl = (): string => settings.VIACEP_BASE_URL
